import { render, staticRenderFns } from "./reclamo-qec-resumen.vue?vue&type=template&id=0fdbb1f5&"
import script from "./reclamo-qec-resumen.vue?vue&type=script&lang=ts&"
export * from "./reclamo-qec-resumen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports